module.exports = __webpack_public_path__ + "img/box-seam.7f807ca0.svg";